function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56.7422 115C83.5281 115 105.242 93.2858 105.242 66.5C105.242 39.7142 83.5281 18 56.7422 18C29.9564 18 8.24225 39.7142 8.24225 66.5C8.24225 93.2858 29.9564 115 56.7422 115Z",
  fill: "#C8DFF1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5395 80.0562C28.8373 80.0553 29.1302 79.9793 29.3909 79.8352C29.6516 79.691 29.8717 79.4835 30.0308 79.2317C31.636 76.5109 32.2767 73.3284 31.8496 70.1985C31.8154 69.9684 31.7361 69.7474 31.6165 69.5479C31.4968 69.3484 31.339 69.1745 31.1521 69.036C30.9652 68.8975 30.7528 68.7972 30.5272 68.7408C30.3015 68.6843 30.0669 68.6729 29.8368 68.7072C29.6068 68.7414 29.3857 68.8206 29.1862 68.9403C28.9867 69.06 28.8128 69.2178 28.6743 69.4047C28.5358 69.5916 28.4355 69.8039 28.3791 70.0296C28.3227 70.2552 28.3112 70.4898 28.3455 70.7199C28.6512 73.0014 28.1951 75.3201 27.0481 77.3159C26.8769 77.5845 26.7808 77.894 26.7699 78.2124C26.7589 78.5307 26.8334 78.8461 26.9856 79.1259C27.1379 79.4056 27.3623 79.6394 27.6356 79.8031C27.9089 79.9667 28.221 80.0541 28.5395 80.0562Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.1043 80.3833C32.4009 80.3826 32.6926 80.308 32.953 80.1661C33.2134 80.0243 33.4343 79.8197 33.5957 79.5709C35.1967 76.8443 35.8331 73.6581 35.4023 70.5256C35.3673 70.2956 35.2873 70.0746 35.1669 69.8755C35.0465 69.6763 34.888 69.5028 34.7006 69.3649C34.5131 69.227 34.3003 69.1273 34.0743 69.0716C33.8483 69.0159 33.6136 69.0053 33.3835 69.0403C33.1534 69.0754 32.9325 69.1554 32.7333 69.2758C32.5342 69.3962 32.3607 69.5547 32.2228 69.7421C32.0848 69.9296 31.9852 70.1424 31.9295 70.3684C31.8738 70.5943 31.8632 70.8291 31.8982 71.0591C32.2021 73.3392 31.7507 75.656 30.613 77.6551C30.366 78.0485 30.2835 78.5232 30.3833 78.9769C30.4831 79.4305 30.7572 79.8267 31.1465 80.0801C31.4285 80.2742 31.762 80.3797 32.1043 80.3833Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.4265 80.7714C35.7231 80.7708 36.0148 80.6962 36.2752 80.5543C36.5356 80.4124 36.7565 80.2079 36.9179 79.9591C38.5222 77.2336 39.1628 74.0476 38.7367 70.9138C38.6387 70.4728 38.3769 70.0855 38.0043 69.8302C37.6317 69.5748 37.176 69.4705 36.7294 69.5382C36.2827 69.606 35.8785 69.8408 35.5984 70.1952C35.3183 70.5496 35.1832 70.9971 35.2204 71.4473C35.5363 73.7277 35.0841 76.0483 33.9352 78.0433C33.6882 78.4367 33.6057 78.9114 33.7055 79.365C33.8053 79.8187 34.0794 80.2149 34.4687 80.4683C34.7507 80.6623 35.0842 80.7679 35.4265 80.7714Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.7329 78.6982C23.9927 80.1411 21.6404 79.1469 19.7125 83.8756L13.3348 97.6133L3.86517 92.7633L10.5824 80.2745C13.6379 73.8604 22.4043 61.9779 31.8982 62.6205C33.5679 62.6712 35.2107 63.0543 36.7306 63.7476C38.2504 64.4409 39.6167 65.4304 40.7494 66.6581L42.0953 68.2222C42.3697 68.5476 42.5177 68.961 42.5122 69.3866C42.5066 69.8122 42.348 70.2215 42.0652 70.5396C41.7824 70.8578 41.3945 71.0634 40.9725 71.1187C40.5504 71.1741 40.1226 71.0756 39.7673 70.8413C39.1247 70.4048 38.3729 69.1438 37.1362 68.0768C33.4987 65.3123 28.2243 65.6517 26.5147 70.5866C26.5014 70.677 26.5074 70.7691 26.5325 70.8569C26.5576 70.9447 26.6011 71.0262 26.6602 71.0959C26.7231 71.1651 26.7999 71.2203 26.8855 71.2579C26.9712 71.2955 27.0638 71.3146 27.1573 71.3141C28.5324 71.2917 29.8921 71.0206 31.1707 70.5139L37.1362 68.0889C37.9496 68.8693 38.7226 69.6909 39.4521 70.5503C39.2236 70.8628 38.935 71.1266 38.6033 71.3263C32.7954 75.0486 31.0616 76.1277 26.7329 78.6982Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.7329 78.6982C23.9927 80.1411 21.6404 79.1469 19.7125 83.8756L13.3348 97.6133L3.86517 92.7633L10.5824 80.2745C13.6379 73.8604 22.4043 61.9779 31.8982 62.6205C33.5679 62.6712 35.2107 63.0543 36.7306 63.7476C38.2504 64.4409 39.6167 65.4304 40.7494 66.6581L42.0953 68.2222C42.3697 68.5476 42.5177 68.961 42.5122 69.3866C42.5066 69.8122 42.348 70.2215 42.0652 70.5396C41.7824 70.8578 41.3945 71.0634 40.9725 71.1187C40.5504 71.1741 40.1226 71.0756 39.7673 70.8413C39.1247 70.4048 38.3729 69.1438 37.1362 68.0768C33.4987 65.3123 28.2243 65.6517 26.5147 70.5866C26.5013 70.677 26.5074 70.7691 26.5325 70.8569C26.5576 70.9448 26.6011 71.0262 26.6602 71.0959C26.7231 71.1651 26.7999 71.2203 26.8855 71.2579C26.9712 71.2955 27.0638 71.3146 27.1573 71.3141C28.5324 71.2917 29.8921 71.0206 31.1707 70.5139L37.1362 68.0889C37.9496 68.8693 38.7226 69.6909 39.4521 70.5503C39.2236 70.8628 38.935 71.1266 38.6033 71.3263C32.7954 75.0486 31.0616 76.1277 26.7329 78.6982Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M37.1361 68.0519L31.1706 70.4769C29.8921 70.9836 28.5324 71.2547 27.1573 71.2771C27.0637 71.2777 26.9711 71.2585 26.8855 71.2209C26.7998 71.1833 26.7231 71.1281 26.6601 71.0589C26.6011 70.9892 26.5576 70.9078 26.5325 70.82C26.5074 70.7322 26.5013 70.64 26.5146 70.5496C28.2243 65.6754 33.4501 65.2874 37.1361 68.0519Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4642 86.9187L14.911 97.3705C14.838 97.5124 14.7377 97.6385 14.6158 97.7416C14.4939 97.8446 14.3529 97.9226 14.2008 97.971C14.0487 98.0195 13.8886 98.0374 13.7296 98.0238C13.5705 98.0102 13.4158 97.9654 13.2741 97.8918L3.2225 92.6902C2.93904 92.5427 2.72526 92.2893 2.62763 91.9851C2.53 91.6808 2.55641 91.3503 2.70112 91.0655L8.24225 80.6137C8.31527 80.4718 8.41559 80.3457 8.53746 80.2426C8.65933 80.1395 8.80034 80.0616 8.95242 80.0131C9.1045 79.9647 9.26464 79.9467 9.42367 79.9603C9.58269 79.9739 9.73747 80.0188 9.87912 80.0923L19.9429 85.2818C20.0848 85.3548 20.2109 85.4552 20.314 85.577C20.417 85.6989 20.495 85.8399 20.5435 85.992C20.5919 86.1441 20.6098 86.3042 20.5962 86.4633C20.5826 86.6223 20.5378 86.777 20.4642 86.9187Z",
  fill: "#F7F8FC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4642 86.9187L14.911 97.3705C14.838 97.5124 14.7377 97.6385 14.6158 97.7415C14.4939 97.8446 14.3529 97.9226 14.2008 97.971C14.0487 98.0195 13.8886 98.0374 13.7296 98.0238C13.5705 98.0102 13.4158 97.9654 13.2741 97.8918L3.2225 92.6902C2.93904 92.5427 2.72526 92.2893 2.62763 91.9851C2.53 91.6808 2.55641 91.3503 2.70112 91.0655L8.24225 80.6137C8.31527 80.4718 8.41559 80.3457 8.53746 80.2426C8.65933 80.1395 8.80034 80.0616 8.95242 80.0131C9.1045 79.9647 9.26464 79.9467 9.42367 79.9603C9.58269 79.9739 9.73747 80.0188 9.87912 80.0923L19.9429 85.2818C20.0848 85.3548 20.2109 85.4552 20.314 85.577C20.417 85.6989 20.495 85.8399 20.5435 85.992C20.5919 86.1441 20.6098 86.3042 20.5962 86.4633C20.5826 86.6223 20.5378 86.777 20.4642 86.9187Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8915 84.156L20.2295 85.438L9.58522 79.9418L10.2472 78.6597C10.3948 78.374 10.6498 78.1586 10.9561 78.0608C11.2625 77.9631 11.5951 77.9911 11.8809 78.1387L20.3704 82.5223C20.6561 82.6699 20.8715 82.9249 20.9693 83.2312C21.067 83.5376 21.039 83.8702 20.8915 84.156Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M86.1454 80.0561C85.8475 80.0552 85.5546 79.9792 85.2939 79.8351C85.0332 79.6909 84.8131 79.4834 84.654 79.2316C83.0542 76.5088 82.4138 73.3282 82.8352 70.1984C82.9344 69.7599 83.1955 69.3751 83.5664 69.121C83.9373 68.867 84.3905 68.7624 84.8352 68.8284C85.2799 68.8943 85.6832 69.1258 85.9644 69.4766C86.2456 69.8274 86.3839 70.2714 86.3515 70.7198C86.0412 73 86.493 75.3189 87.6367 77.3158C87.8837 77.7092 87.9662 78.1839 87.8664 78.6375C87.7666 79.0912 87.4925 79.4874 87.1032 79.7408C86.8222 79.9385 86.4888 80.0482 86.1454 80.0561Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M82.6048 80.3833C82.3066 80.3824 82.0133 80.3078 81.751 80.1661C81.4886 80.0243 81.2654 79.8199 81.1013 79.5709C79.5057 76.8422 78.8697 73.6579 79.2947 70.5256C79.3297 70.2956 79.4097 70.0746 79.5302 69.8755C79.6506 69.6763 79.809 69.5028 79.9965 69.3649C80.184 69.227 80.3968 69.1273 80.6227 69.0716C80.8487 69.0159 81.0834 69.0053 81.3135 69.0403C81.5436 69.0754 81.7645 69.1554 81.9637 69.2758C82.1629 69.3962 82.3364 69.5547 82.4743 69.7421C82.6122 69.9296 82.7119 70.1424 82.7675 70.3684C82.8232 70.5943 82.8339 70.8291 82.7988 71.0591C82.4931 73.3407 82.9492 75.6593 84.0962 77.6551C84.3401 78.0494 84.4208 78.5231 84.3212 78.9758C84.2216 79.4286 83.9495 79.8247 83.5627 80.0801C83.2797 80.2722 82.9468 80.3775 82.6048 80.3833Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M79.2704 80.7718C78.9739 80.7712 78.6822 80.6965 78.4218 80.5547C78.1614 80.4128 77.9404 80.2082 77.7791 79.9594C76.1781 77.2328 75.5417 74.0466 75.9724 70.9142C76.0075 70.6841 76.0875 70.4632 76.2079 70.264C76.3283 70.0648 76.4867 69.8914 76.6742 69.7534C76.8617 69.6155 77.0745 69.5159 77.3005 69.4602C77.5264 69.4045 77.7612 69.3939 77.9912 69.4289C78.2213 69.4639 78.4423 69.5439 78.6414 69.6643C78.8406 69.7847 79.0141 69.9432 79.152 70.1307C79.2899 70.3181 79.3896 70.5309 79.4453 70.7569C79.501 70.9829 79.5116 71.2176 79.4766 71.4477C79.1727 73.7277 79.6241 76.0445 80.7618 78.0437C81.0088 78.4371 81.0913 78.9118 80.9915 79.3654C80.8917 79.8191 80.6176 80.2153 80.2283 80.4687C79.9462 80.6627 79.6127 80.7682 79.2704 80.7718Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M87.952 78.6982C90.6922 80.1411 93.0445 79.1469 94.9724 83.8756L101.617 97.6133L111.074 92.7633L104.09 80.2745C101.047 73.8604 92.2685 61.9779 82.7746 62.6205C81.1067 62.6714 79.4658 63.0548 77.948 63.7481C76.4301 64.4414 75.066 65.4308 73.9355 66.6581L72.6017 68.198C72.3193 68.5233 72.1652 68.9404 72.1683 69.3712C72.1713 69.802 72.3314 70.2169 72.6184 70.5381C72.9054 70.8593 73.2998 71.0649 73.7275 71.1162C74.1552 71.1676 74.587 71.0612 74.9419 70.817C75.5845 70.3805 76.3241 69.1195 77.573 68.0525C81.2105 65.288 86.4727 65.6275 88.1945 70.5624C88.2062 70.6536 88.1982 70.7463 88.171 70.8341C88.1438 70.922 88.0981 71.003 88.0369 71.0716C87.9755 71.1427 87.899 71.1992 87.813 71.237C87.727 71.2748 87.6336 71.2928 87.5397 71.2899C86.1647 71.2664 84.8052 70.9953 83.5264 70.4896L77.573 68.0646C76.7554 68.8537 75.9822 69.6876 75.2571 70.5624C75.4811 70.8746 75.7656 71.1385 76.0937 71.3384C81.8895 75.0486 83.6476 76.1277 87.952 78.6982Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M87.952 78.6982C90.6922 80.1411 93.0445 79.1469 94.9724 83.8756L101.617 97.6133L111.074 92.7633L104.09 80.2745C101.047 73.8604 92.2685 61.9779 82.7746 62.6205C81.1067 62.6714 79.4658 63.0548 77.948 63.7481C76.4301 64.4414 75.066 65.4308 73.9355 66.6581L72.6017 68.198C72.3193 68.5233 72.1652 68.9404 72.1683 69.3712C72.1713 69.802 72.3314 70.2169 72.6184 70.5381C72.9054 70.8593 73.2998 71.0649 73.7275 71.1162C74.1552 71.1676 74.587 71.0612 74.9419 70.817C75.5845 70.3805 76.3241 69.1195 77.573 68.0525C81.2105 65.288 86.4727 65.6275 88.1945 70.5624C88.2062 70.6536 88.1982 70.7463 88.171 70.8341C88.1438 70.922 88.0981 71.003 88.0369 71.0716C87.9755 71.1427 87.899 71.1992 87.813 71.237C87.727 71.2748 87.6336 71.2928 87.5397 71.2899C86.1647 71.2664 84.8052 70.9953 83.5264 70.4896L77.573 68.0646C76.7554 68.8537 75.9822 69.6876 75.2571 70.5624C75.4811 70.8746 75.7656 71.1385 76.0937 71.3384C81.8895 75.0486 83.6476 76.1277 87.952 78.6982Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M77.573 68.0519L83.5264 70.4769C84.8052 70.9826 86.1647 71.2537 87.5397 71.2771C87.6336 71.2801 87.727 71.262 87.813 71.2243C87.899 71.1865 87.9755 71.13 88.0369 71.0589C88.0981 70.9902 88.1438 70.9092 88.171 70.8214C88.1982 70.7335 88.2062 70.6409 88.1945 70.5496C86.4727 65.6754 81.2469 65.2874 77.573 68.0519Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M78.4097 83.5598C65.1873 88.2888 50.7345 88.2888 37.5121 83.5598C37.2735 83.4764 37.067 83.3206 36.9213 83.114C36.7757 82.9075 36.6982 82.6607 36.6997 82.4079V56.4362C36.7005 56.243 36.7474 56.0528 36.8366 55.8814C36.9258 55.71 37.0546 55.5624 37.2124 55.4509C37.3702 55.3393 37.5523 55.2671 37.7437 55.2403C37.935 55.2134 38.13 55.2327 38.3124 55.2964C51.0456 59.6495 64.8641 59.6495 77.5974 55.2964C77.7797 55.2327 77.9747 55.2134 78.166 55.2403C78.3574 55.2671 78.5395 55.3393 78.6973 55.4509C78.8551 55.5624 78.9839 55.71 79.0731 55.8814C79.1623 56.0528 79.2092 56.243 79.21 56.4362V82.4079C79.2124 82.6592 79.1367 82.905 78.9933 83.1113C78.85 83.3177 78.646 83.4744 78.4097 83.5598Z",
  fill: "#F7F8FC"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M78.4097 83.5598C65.1873 88.2888 50.7345 88.2888 37.5121 83.5598C37.2735 83.4764 37.067 83.3206 36.9213 83.114C36.7757 82.9075 36.6982 82.6607 36.6997 82.4079V56.4362C36.7005 56.243 36.7474 56.0528 36.8366 55.8814C36.9258 55.71 37.0546 55.5624 37.2124 55.4509C37.3702 55.3393 37.5523 55.2671 37.7437 55.2403C37.935 55.2134 38.13 55.2327 38.3124 55.2964C51.0456 59.6495 64.8641 59.6495 77.5974 55.2964C77.7797 55.2327 77.9747 55.2134 78.1661 55.2403C78.3574 55.2671 78.5395 55.3393 78.6973 55.4509C78.8551 55.5624 78.9839 55.71 79.0731 55.8814C79.1623 56.0528 79.2092 56.243 79.21 56.4362V82.4079C79.2124 82.6592 79.1367 82.905 78.9933 83.1113C78.85 83.3177 78.646 83.4744 78.4097 83.5598Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M79.21 61.7106C65.5043 66.8414 50.4053 66.8414 36.6997 61.7106V56.4362C36.7005 56.243 36.7474 56.0528 36.8366 55.8814C36.9258 55.71 37.0546 55.5624 37.2124 55.4509C37.3702 55.3393 37.5523 55.2671 37.7436 55.2403C37.935 55.2134 38.13 55.2327 38.3123 55.2964C51.0456 59.6495 64.8641 59.6495 77.5973 55.2964C77.7797 55.2327 77.9747 55.2134 78.166 55.2403C78.3574 55.2671 78.5395 55.3393 78.6973 55.4509C78.8551 55.5624 78.9839 55.71 79.0731 55.8814C79.1623 56.0528 79.2092 56.243 79.21 56.4362V61.7106Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M79.21 61.7106C65.5043 66.8414 50.4053 66.8414 36.6997 61.7106V56.4362C36.7005 56.243 36.7474 56.0528 36.8366 55.8814C36.9258 55.71 37.0546 55.5624 37.2124 55.4509C37.3702 55.3393 37.5523 55.2671 37.7436 55.2403C37.935 55.2134 38.13 55.2327 38.3123 55.2964C51.0456 59.6495 64.8641 59.6495 77.5973 55.2964C77.7797 55.2327 77.9747 55.2134 78.166 55.2403C78.3574 55.2671 78.5395 55.3393 78.6973 55.4509C78.8551 55.5624 78.9839 55.71 79.0731 55.8814C79.1623 56.0528 79.2092 56.243 79.21 56.4362V61.7106Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M45.4175 82.3236C57.7002 84.9305 64.3083 84.688 76.3363 80.7716",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M51.9651 82.178V84.506",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M40.1552 79.8376V82.1656",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M42.4833 80.4563V82.7843",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3192 59.7462C41.331 59.8943 41.303 60.043 41.2383 60.1768C41.1736 60.3106 41.0744 60.4247 40.9509 60.5075C40.8274 60.5902 40.6841 60.6385 40.5357 60.6475C40.3873 60.6565 40.2392 60.6258 40.1067 60.5585C39.7738 60.4564 39.4797 60.2557 39.2632 59.9829C39.0468 59.7101 38.9181 59.3782 38.8942 59.0308C38.8807 58.8824 38.9077 58.733 38.9723 58.5987C39.0369 58.4644 39.1368 58.3502 39.2611 58.2681C39.3855 58.186 39.5298 58.1391 39.6787 58.1325C39.8276 58.1259 39.9755 58.1598 40.1067 58.2305C40.4386 58.3304 40.7323 58.5289 40.9489 58.7996C41.1654 59.0703 41.2946 59.4004 41.3192 59.7462Z",
  fill: "#F7F8FC",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M45.4176 60.7654C45.4175 60.9023 45.3865 61.0374 45.3269 61.1606C45.2673 61.2839 45.1807 61.3921 45.0734 61.4772C44.9662 61.5623 44.8411 61.622 44.7076 61.6521C44.574 61.6821 44.4354 61.6815 44.3021 61.6505C43.9714 61.5686 43.6756 61.3833 43.4575 61.1216C43.2394 60.8599 43.1105 60.5355 43.0896 60.1955C43.0809 60.0468 43.11 59.8982 43.1741 59.7637C43.2381 59.6292 43.3351 59.513 43.456 59.426C43.5769 59.3389 43.7179 59.2838 43.8658 59.2657C44.0137 59.2476 44.1637 59.2672 44.3021 59.3225C44.6184 59.4111 44.8978 59.5993 45.0987 59.8592C45.2997 60.1192 45.4115 60.4369 45.4176 60.7654Z",
  fill: "#F7F8FC",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5764 61.5048C49.5806 61.6556 49.55 61.8055 49.4869 61.9426C49.4239 62.0797 49.3301 62.2004 49.2128 62.2954C49.0955 62.3904 48.9579 62.4571 48.8107 62.4903C48.6635 62.5235 48.5106 62.5224 48.3639 62.4869C48.0355 62.4317 47.736 62.2656 47.5153 62.0163C47.2947 61.7669 47.1662 61.4494 47.1514 61.1168C47.1485 60.9672 47.1802 60.8189 47.2442 60.6836C47.3081 60.5483 47.4025 60.4297 47.5199 60.3369C47.6373 60.2442 47.7746 60.1798 47.921 60.1489C48.0674 60.1181 48.219 60.1215 48.3639 60.1589C48.6902 60.2089 48.9893 60.3702 49.2102 60.6155C49.4312 60.8608 49.5606 61.175 49.5764 61.5048Z",
  fill: "#F7F8FC",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M56.7544 72.4294V76.2003C56.754 76.417 56.8116 76.6298 56.9213 76.8166C57.031 77.0034 57.1887 77.1574 57.3781 77.2627C57.5675 77.3679 57.7816 77.4204 57.9981 77.4148C58.2147 77.4093 58.4258 77.3458 58.6095 77.2309C59.7008 76.5519 60.6223 75.9457 61.7378 75.1818C61.9079 75.0641 62.0451 74.9047 62.1362 74.719C62.2274 74.5333 62.2695 74.3273 62.2585 74.1207C62.2476 73.9141 62.184 73.7138 62.0737 73.5387C61.9635 73.3636 61.8103 73.2197 61.6287 73.1206C60.5617 72.5264 59.6644 72.0051 58.6095 71.3624C58.4232 71.2458 58.2087 71.182 57.9889 71.1779C57.7691 71.1738 57.5523 71.2296 57.3618 71.3392C57.1712 71.4488 57.014 71.6081 56.907 71.8002C56.8001 71.9922 56.7473 72.2097 56.7544 72.4294Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M94.2449 86.9187L100.077 97.3705C100.15 97.5124 100.25 97.6385 100.372 97.7416C100.494 97.8446 100.635 97.9226 100.787 97.971C100.939 98.0195 101.099 98.0374 101.258 98.0238C101.417 98.0102 101.572 97.9654 101.714 97.8918L111.778 92.6902C112.061 92.5427 112.275 92.2893 112.372 91.9851C112.47 91.6808 112.444 91.3503 112.299 91.0655L106.479 80.6137C106.406 80.4718 106.306 80.3457 106.184 80.2426C106.062 80.1395 105.921 80.0616 105.769 80.0131C105.617 79.9647 105.457 79.9467 105.298 79.9603C105.139 79.9739 104.984 80.0188 104.842 80.0923L94.7905 85.2818C94.6465 85.3527 94.518 85.4515 94.4125 85.5724C94.3069 85.6933 94.2264 85.834 94.1757 85.9863C94.1249 86.1385 94.1049 86.2994 94.1168 86.4594C94.1287 86.6195 94.1722 86.7756 94.2449 86.9187Z",
  fill: "#F7F8FC"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M94.2449 86.9187L100.077 97.3705C100.15 97.5124 100.25 97.6385 100.372 97.7415C100.494 97.8446 100.635 97.9226 100.787 97.971C100.939 98.0195 101.099 98.0374 101.258 98.0238C101.417 98.0102 101.572 97.9654 101.714 97.8918L111.778 92.6902C112.061 92.5427 112.275 92.2893 112.372 91.9851C112.47 91.6808 112.444 91.3503 112.299 91.0655L106.479 80.6137C106.406 80.4718 106.306 80.3457 106.184 80.2426C106.062 80.1395 105.921 80.0616 105.769 80.0131C105.617 79.9647 105.457 79.9467 105.298 79.9603C105.139 79.9739 104.984 80.0188 104.842 80.0923L94.7905 85.2818C94.6465 85.3527 94.518 85.4515 94.4125 85.5724C94.3069 85.6933 94.2264 85.834 94.1757 85.9863C94.1249 86.1385 94.1049 86.2994 94.1168 86.4594C94.1287 86.6195 94.1722 86.7756 94.2449 86.9187Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinejoin: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M104.446 78.6544L105.108 79.9364L94.4633 85.4327L93.8013 84.1506C93.6538 83.8649 93.6258 83.5323 93.7235 83.2259C93.8212 82.9195 94.0367 82.6645 94.3224 82.517L102.812 78.1333C103.098 77.9858 103.43 77.9578 103.737 78.0555C104.043 78.1532 104.298 78.3686 104.446 78.6544Z",
  fill: "white",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M87.5398 71.3505C86.1648 71.327 84.8052 71.0559 83.5264 70.5502L77.573 68.1252C77.307 68.0359 77.0291 67.9868 76.7485 67.9797C76.279 67.9797 75.8287 68.1662 75.4968 68.4982C75.1648 68.8302 74.9783 69.2805 74.9783 69.75C75.0155 70.0888 75.1371 70.4128 75.332 70.6925C75.5268 70.9721 75.7888 71.1983 76.0938 71.3505C81.9138 75.0729 83.6476 76.2005 87.9763 78.7225",
  fill: "white"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M87.5398 71.3505C86.1648 71.327 84.8052 71.0559 83.5264 70.5502L77.573 68.1252C77.307 68.0359 77.0291 67.9868 76.7485 67.9797C76.279 67.9797 75.8287 68.1662 75.4968 68.4982C75.1648 68.8302 74.9783 69.2805 74.9783 69.75C75.0155 70.0888 75.1371 70.4128 75.332 70.6925C75.5268 70.9721 75.7888 71.1983 76.0938 71.3505C81.9138 75.0729 83.6476 76.2005 87.9763 78.7225",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1573 71.3505C28.5324 71.3281 29.8921 71.0569 31.1707 70.5502L37.1362 68.1252C37.3978 68.0349 37.6718 67.9858 37.9485 67.9797C38.418 67.9797 38.8683 68.1662 39.2003 68.4982C39.5323 68.8302 39.7188 69.2805 39.7188 69.75C39.6816 70.0888 39.56 70.4128 39.3651 70.6925C39.1702 70.9721 38.9083 71.1983 38.6033 71.3505C32.7954 75.0729 31.0615 76.2005 26.7329 78.7225",
  fill: "white"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1573 71.3505C28.5324 71.3281 29.8921 71.0569 31.1707 70.5502L37.1362 68.1252C37.3978 68.0349 37.6718 67.9858 37.9485 67.9797C38.418 67.9797 38.8683 68.1662 39.2003 68.4982C39.5323 68.8302 39.7188 69.2805 39.7188 69.75C39.6816 70.0888 39.56 70.4128 39.3651 70.6925C39.1702 70.9721 38.9083 71.1983 38.6033 71.3505C32.7954 75.0729 31.0615 76.2005 26.7329 78.7225",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M48.861 32.5502V30.1252",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6486 31.3376H50.0736",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M44.0111 51.95V49.525",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M42.7985 50.7377H45.2235",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M89.4797 56.194V51.344",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M87.0548 53.7688H91.9048",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8235 53.1626V48.3126",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3986 50.7377H28.2486",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M78.5673 38.6127H77.3548C77.02 38.6127 76.7485 38.8841 76.7485 39.2189V44.0689C76.7485 44.4037 77.02 44.6752 77.3548 44.6752H78.5673C78.9021 44.6752 79.1735 44.4037 79.1735 44.0689V39.2189C79.1735 38.8841 78.9021 38.6127 78.5673 38.6127Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M83.4173 38.6127H82.2048C81.87 38.6127 81.5986 38.8841 81.5986 39.2189V44.0689C81.5986 44.4037 81.87 44.6752 82.2048 44.6752H83.4173C83.7521 44.6752 84.0236 44.4037 84.0236 44.0689V39.2189C84.0236 38.8841 83.7521 38.6127 83.4173 38.6127Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M61.2771 27.9669C61.0928 27.8605 60.8837 27.8044 60.6708 27.8044C60.458 27.8044 60.2489 27.8605 60.0646 27.9669C59.8836 28.0742 59.7336 28.2268 59.6295 28.4096C59.5253 28.5924 59.4705 28.7992 59.4705 29.0096V39.1946C59.4705 39.4051 59.5253 39.6118 59.6295 39.7947C59.7336 39.9775 59.8836 40.1301 60.0646 40.2374C60.2489 40.3438 60.458 40.3998 60.6708 40.3998C60.8837 40.3998 61.0928 40.3438 61.2771 40.2374L70.8316 35.1449C71.0241 35.041 71.1849 34.887 71.2969 34.6991C71.409 34.5113 71.4682 34.2966 71.4682 34.0779C71.4682 33.8592 71.409 33.6445 71.2969 33.4567C71.1849 33.2688 71.0241 33.1148 70.8316 33.0109L61.2771 27.9669Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M67.0486 46.7972V45.8878",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M68.9764 47.5975L69.619 46.9548",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M69.7767 49.525H70.6861",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M68.9764 51.4531L69.619 52.0957",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M67.0486 52.2532V53.1625",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M65.1206 51.4531L64.478 52.0957",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M64.3204 49.525H63.4111",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M65.1206 47.5975L64.478 46.9548",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M36.736 43.4625C38.4101 43.4625 39.7673 42.1054 39.7673 40.4313C39.7673 38.7572 38.4101 37.4 36.736 37.4C35.0619 37.4 33.7048 38.7572 33.7048 40.4313C33.7048 42.1054 35.0619 43.4625 36.736 43.4625Z",
  stroke: "#1B75BB",
  strokeWidth: 1.13,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTutorialImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 127,
    viewBox: "0 0 113 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialImage);
export default __webpack_public_path__ + "static/media/tutorial-image.55a034c1.svg";
export { ForwardRef as ReactComponent };